import { Province } from '../../../@types/KingdomResponse';
import { KanbanColumn, KanbanItem, KdKanban } from '../../../@types/State';

export const enrichProvinces = (
  plan: KdKanban | undefined,
  dataSet: Province[] | undefined
) => {
  if (!dataSet) return null;
  const newProvinces: Province[] = dataSet.map((p: Province) => {
    return { ...p };
  });

  if (plan) {
    plan.columns.forEach((c: KanbanColumn) => {
      c.items.forEach((i: KanbanItem) => {
        const province = newProvinces.find(
          (p: Province) => p.id === i.province.id
        );
        if (province) {
          province['group'] = c.title === 'Unassigned' ? '' : c.title;
          province['note'] = i.content;
          province['requiredOps'] = i.province.requiredOps;
          province['requiredObjectives'] = i.province.requiredObjectives;
        }
      });
    });
  }
  return newProvinces;
};

export const getMaxSpellCount = (dataSet: Province[] | undefined) => {
  let maxGood = 0;
  let maxBad = 0;
  if (dataSet && dataSet.length > 0)
    dataSet.forEach((province: Province) => {
      if (province.sot) {
        maxGood = Math.max(maxGood, province.sot.goodSpells.length);
        maxBad = Math.max(maxBad, province.sot.badSpells.length);
      }
    });
  return [maxGood, maxBad];
};
